import { render, staticRenderFns } from "./aztecempire.vue?vue&type=template&id=7ee36781&scoped=true"
import script from "./aztecempire.vue?vue&type=script&lang=js"
export * from "./aztecempire.vue?vue&type=script&lang=js"
import style0 from "./aztecempire.vue?vue&type=style&index=0&id=7ee36781&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ee36781",
  null
  
)

export default component.exports